<!--
   Created by qing on 2020/8/6
   Des: 
-->
<template>
  <van-popup
    class="form-data-filter-popup"
    v-model="visible"
    :style="{ height: '90%' }"
    get-container="body"
    position="bottom">
    <div class="filter-popup-container">
      <div class="header">
        <div class="left">
          <div class="title">
            筛选出符合以下
            <span @click="relationConfig.open">
            <span v-if="filter.relation === 'and'">所有</span>
            <span v-if="filter.relation === 'or'">任一</span>
            <van-icon name="arrow-down"/>
          </span>
            条件的数据
          </div>
          <div class="add" @click="addFilterCondition">
            添加筛选条件 <van-icon name="plus" />
          </div>
        </div>
        <div class="btn" @click="resetFilter">
          <van-icon name="replay"/>
          <span>重置筛选</span>
        </div>
      </div>

      <div class="content" v-if="visible">
        <template v-if="filter.conditionList && filter.conditionList.length">
          <div
            v-for="condition in filter.conditionList"
            :key="condition.fieldId">
            <FilterContainer
              :field="fetchFieldFormFieldId(condition.fieldId)"
              :fields="fieldsOpts"
              :fieldType="fetchFieldFormFieldId(condition.fieldId).type"
              :filter="condition"
              :formId="formId"
              :filterWay="false"
              :companyId="$store.getters.currentCompanyId"
              :appId="$store.getters.currentAppId"
              @deleteCondition="deleteCondition">
            </FilterContainer>
          </div>
        </template>

        <div
          v-else
          class="empty-container"
          @click="addFilterCondition">
          请添加筛选条件
        </div>
      </div>
      <div class="footer">
        <van-button type="default" @click="onClickCancel">取消</van-button>
        <van-button type="primary" @click="onClickConfirm">确定</van-button>
      </div>
    </div>

    <!--选择relation）-->
    <van-action-sheet
      v-model="relationConfig.visible"
      :actions="relationConfig.relationOpts"
      @select="relationConfig.confirm"
      cancel-text="取消"
      get-container="body"
      close-on-click-action/>

    <!--选择field-->
    <van-popup
      class="select-field-popup"
      v-model="selectFieldConfig.visible"
      :style="{ width: '80%' }"
      get-container="body"
      position="right">
      <div class="header">
        <div class="btn" @click="selectFieldConfig.visible = false">
          <van-icon name="arrow-left" />
          返回
        </div>
        <div class="des">
          点击下列控件，添加相应筛选条件
        </div>

      </div>
      <div class="field-container">
        <div
          class="field-item"
          v-for="field in fieldsOpts"
          :key="field.dataId"
          :style="{color: filedDisable(field) ? `#bbb` : `#333333`}"
          @click="selectFieldConfig.confirm(field)">
          <i :class="formIconMap[field.type]"></i>
          {{field.fieldTitle}}
        </div>
      </div>
    </van-popup>
  </van-popup>
</template>

<script>
  import {
    FILTER_METHOD_TYPE__EQ,
    FILTER_METHOD_TYPE__ALL,
    FILTER_METHOD_TYPE__EMPTY,
    FILTER_METHOD_TYPE__NOT_EMPTY,
    FILTER_METHOD_TYPE__IN,
    FILTER_METHOD_TYPE__NIN,
    FILTER_METHOD_TYPE__LIKE,
    FILTER_METHOD_TYPE__UNLIKE,
    FILTER_METHOD_TYPE__RANGE
  } from "./FilterWidget/types"
  import {formatDate, arrayRemove, clone, fetchFieldFilterOpts} from "../../assets/js/Untis"
  import {
    FORM_TYPE__FILL,
    FORM_ITEM__DATE,
    FORM_ITEM__NUMBER,
    FORM_ITEM__CURRENCY,
    FORM_ITEM__SINGLE_LINE,
    FORM_ITEM__MULTILINE,
    FORM_ITEM__SERIAL_NUMBER,
    FORM_ITEM__PHONE, FORM_ITEM__DROPDOWN,
    FORM_ITEM__SINGLE_CHOOSE,
    FORM_ITEM__CHECKBOX,
    FORM_ITEM__LOCATION,
    FORM_ITEM__IMAGE,
    FORM_ITEM__ATTACHMENT
  } from "../RyForm/types";
  import {SUCCESS} from "../store/types";
  import FormSet from "../RyForm";
  import PinyinMatch from 'pinyin-match'
  import FilterContainer from "./FilterWidget/FilterContainer";
  import {formIconMap} from "../RyForm/instances"

  export default {
    name: 'form-data-filter',
    props: {
      formId: {
        type: String,
        default: ''
      },
      formFields: {
        type: Array,
        default: () => []
      }
    },
    components: {
      FilterContainer
    },
    data() {
      return {
        visible: false,
        endLoading: false,
        formIconMap,
        FORM_ITEM__DATE,
        FORM_ITEM__NUMBER,
        FORM_ITEM__CURRENCY,
        FORM_ITEM__SINGLE_LINE,
        FORM_ITEM__MULTILINE,
        FORM_ITEM__SERIAL_NUMBER,
        FORM_ITEM__PHONE,
        FORM_ITEM__LOCATION,
        FORM_ITEM__IMAGE,
        FORM_ITEM__ATTACHMENT,
        FILTER_METHOD_TYPE__EQ,
        FILTER_METHOD_TYPE__RANGE,
        FILTER_METHOD_TYPE__EMPTY,
        FILTER_METHOD_TYPE__NOT_EMPTY,
        FILTER_METHOD_TYPE__LIKE,
        FILTER_METHOD_TYPE__UNLIKE,
        formSet: FormSet.init({
          userId: this.$store.getters.userId,
          companyId: this.$store.getters.currentCompanyId,
          formId: this.formId,
          appId: this.appId
        }),
        fields: [],
        addFields: [
          {
            dataId: 'userId',
            fieldTitle: '申请人',
            type: FormSet.TYPES.FORM_ITEM__SINGLE_LINE,
            dataType: FormSet.TYPES.DATA_TYPE__STRING,
            filterOpts: fetchFieldFilterOpts(FormSet.TYPES.DATA_TYPE__STRING),
            color: '#3f80ae'
          },
          {
            dataId: 'updateTime',
            fieldTitle: '更新时间',
            type: FormSet.TYPES.FORM_ITEM__DATE,
            dataType: FormSet.TYPES.DATA_TYPE__LONG,
            filterOpts: fetchFieldFilterOpts(FormSet.TYPES.FORM_ITEM__DATE),
            color: '#3f80ae'
          },
          {
            dataId: 'applyTime',
            fieldTitle: '申请时间',
            type: FormSet.TYPES.FORM_ITEM__DATE,
            dataType: FormSet.TYPES.DATA_TYPE__LONG,
            filterOpts: fetchFieldFilterOpts(FormSet.TYPES.FORM_ITEM__DATE),
            color: '#3f80ae'
          },
          {
            dataId: 'from',
            fieldTitle: '数据来源',
            type: FormSet.TYPES.FORM_ITEM__SINGLE_LINE,
            dataType: FormSet.TYPES.DATA_TYPE__STRING,
            filterOpts: fetchFieldFilterOpts(FormSet.TYPES.FORM_ITEM__SINGLE_LINE),
            color: '#3f80ae'
          },
          {
            dataId: 'formRunStatus',
            fieldTitle: '流程状态',
            type: FormSet.TYPES.FORM_ITEM__FORM_RUN_STATUS,
            dataType: FormSet.TYPES.DATA_TYPE__STRING,
            filterOpts: fetchFieldFilterOpts(FormSet.TYPES.FORM_ITEM__FORM_RUN_STATUS),
            color: '#3f80ae'
          },
          {
            dataId: 'flowDetailInfo',
            fieldTitle: '当前节点',
            type: FormSet.TYPES.FORM_ITEM__FLOW_DETAIL_INFO,
            dataType: FormSet.TYPES.DATA_TYPE__STRING,
            filterOpts: fetchFieldFilterOpts(FormSet.TYPES.FORM_ITEM__FLOW_DETAIL_INFO),
            color: '#3f80ae'
          }
        ],
        filter: {
          relation: "and",  // 条件之间的关系 and查询 或者 or 查询
          notJumpEmpty: 0, //是否不跳过空值过滤 0 跳过 1 不跳过
          conditionList: []
        },

        // 选择filter的relation
        relationConfig: {
          visible: false,
          relationOpts: [
            {
              value: "and",
              name: "所有"
            },
            {
              value: "or",
              name: "任一"
            },
          ],
          open: () => {
            this.relationConfig.visible = true
          },
          confirm: (item) => {
            this.filter.relation = item.value
            this.relationConfig.visible = false
          }
        },

        selectFieldConfig: {
          visible: false,

          open:() => {
            this.selectFieldConfig.visible = true
          },
          confirm: (item) => {
            if (this.filedDisable(item)) {
              return
            }
            this.filter.conditionList.push({
              type: item.type,
              dataType: item.dataType,
              method: this.actionFetchFieldFilterOpts(item.type)[0].method, // 匹配的方法
              value: [], // 匹配的值
              fieldId: item.dataId,
              fixedValue: "fixed_value"
            })

          }
        }
      }
    },
    created() {
      if (!this.formFields || !this.formFields.length) {
        this.fetchFieldList()
      }
    },
    computed: {
      fieldsOpts() {
        return this.formFields.length ?  [...this.formFields, ...this.addFields] : this.fields
      }
    },
    methods: {
      open(filter) {
        if (filter && filter.hasOwnProperty('conditionList') && filter.hasOwnProperty('relation')) this.filter = clone(filter)
        this.visible = true
      },
      resetFilter() {
        // this.filter.conditionList.forEach(con => {
        //   con.method = this.actionFetchFieldFilterOpts(con.type)[0].method
        //   con.value.splice(0, con.value.length)
        //   con.fixedValue = "fixed_value"
        // })
        this.filter.conditionList.splice(0, this.filter.conditionList.length)
      },
      fetchFieldList() {
        this.endLoading = false
        this.$store.dispatch('actionMergeStructure', {
          formId: this.formId,
          formType: FORM_TYPE__FILL,
          viewType: 3
        })
          .then(({status, resultObject, info}) => {
            if (status === SUCCESS) {
              this.formSet.setStructure(resultObject.structureInfo)
              this.formSet.setPermission(resultObject.permissionInfo.permissionList)
              this.formSet.setConf(resultObject.detailInfo)
              this.fields = this.formSet.filterField({
                invertType: [
                  FormSet.TYPES.FORM_ITEM__SECTION,
                  FormSet.TYPES.FORM_ITEM__DATE_RANGE,
                  FormSet.TYPES.FORM_ITEM__RTF,
                  FormSet.TYPES.FORM_ITEM__TABLE,
                  FormSet.TYPES.FORM_ITEM__SUMMARY,
                  FormSet.TYPES.FORM_ITEM__DESCRIPTION,
                  FormSet.TYPES.FORM_ITEM__BUTTON
                ]
              })
              this.fields.forEach(field => {
                if (field.parent.type === FormSet.TYPES.FORM_ITEM__TABLE) {
                  field.fieldTitle = `${field.parent.title} • ${field.title}`
                }
              })
              this.fields.push(...this.addFields)
              console.log('fields',this.fields)
            } else {
              throw new Error(`${status}: ${info}`)
            }
          }).finally(() => {
          this.endLoading = true
        })
      },

      addFilterCondition() {
        this.selectFieldConfig.open()
      },

      filedDisable(field) {
        return this.filter.conditionList.some(item => item.fieldId === field.dataId)
      },

      fetchFieldFormFieldId(fieldId) {
        return this.fieldsOpts.filter(field => field.dataId === fieldId)[0] || {}
      },

      actionFetchFieldFilterOpts(fieldType) {
        return fetchFieldFilterOpts(fieldType)
      },

      // 选择method
      onClickMethod(item) {
        this.methodDialogConfig.open(item)
      },

      // 点击选择数据
      onClickSelectFilterData(item) {
        this.selectDataConfig.open(item)
      },

      actionFormatTime(d) {
        if (!d || d <= 0) {
          return ''
        }
        return formatDate(d)('yyyy-MM-dd HH:mm')
      },
      onClickCancel() {
        this.visible = false
      },
      onClickConfirm() {
        console.log('filter', this.filter)
        this.$emit('selectFilterComplete', clone(this.filter))
        this.visible = false
      },

      deleteCondition(condition) {
        arrayRemove(this.filter.conditionList, condition)
      }
    }
  }
</script>

<style lang="less">
  .form-data-filter-popup {
    height: 100%;

    .filter-popup-container {
      height: calc(100% - env(safe-area-inset-bottom));

      .header {
        line-height: 54px;
        padding: 0 20px;
        border-bottom: 1px solid #e6e6e6;
        display: flex;
        justify-content: space-between;
        font-size: 14px;

        .left {

          .title {
            line-height: 30px;

            span {
              color: #4A66FA;
            }
          }

          .add {
            line-height: 24px;
            color: #3a8ee6;
          }
        }


        .btn {
          color: #05A971;

          span {
            margin-left: 5px;
          }
        }
      }

      .content {
        height: calc(100% - 44px - 55px);
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        padding: 0 10px;


        .field-item-container {
          margin: 10px;

          .item-header {
            display: flex;
            line-height: 30px;
            align-items: center;
            font-size: 14px;

            .field-title {

            }

            .field-method {
              color: #4A66FA;
              margin-left: 20px;
            }

            .filter-clear {
              font-size: 12px;
              color: #959699;
              margin-left: 20px;
            }
          }

          .filter-content {
            border: 1px dashed #e6e6e6;
            min-height: 40px;
            padding: 10px;
            font-size: 14px;
            color: #323233;

            .van-tag {
              margin: 0 5px 5px 5px;
            }

            .van-cell {
              padding: 0;
            }

            .van-radio-group {
              display: flex;

              .van-radio {
                margin-right: 20px;
              }
            }
          }
        }

        .empty-container {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .footer {
        height: 44px;

        .van-button {
          width: 50%;
        }
      }
    }
  }

  .select-field-popup {
    height: 100%;

    .header {
      height: 64px;
      font-size: 14px;
      padding: 10px;
      border-bottom: 1px solid #e6e6e6;

      .btn {
        margin-top: 5px;
      }

      .des {
        color: #959699;
        margin-top: 10px;
        font-size: 12px;
      }
    }

    .field-container {
      height: calc(100% - 64px);
      overflow: auto;
      padding: 10px;

      .field-item {
        color: #333333;
        font-size: 14px;
        line-height: 40px;
        border-bottom: 1px solid #e6e6e6;

        i {
          margin-right: 10px;
        }
      }
    }
  }
</style>